import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md";
import { ActionIcon, Menu } from "@mantine/core";
import { supportedLngs } from "./config";

export const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const handleLanguageChange = (language: string) => {
        i18n.changeLanguage(language);
    };

    return (
        <Menu position="bottom-start" shadow="md" width={180}>
            <Menu.Target>
                <ActionIcon variant="subtle" color="dark.6" radius="lg">
                    <MdLanguage size={20} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {Object.entries(supportedLngs).map(([code, details]) => (
                    <Menu.Item key={code} onClick={() => handleLanguageChange(code)}>
                        {details.name}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
};
